import type {
  PlanPositioningCoordinateInfos,
  PlanPositioningCoordinates,
} from "./position-plan-positioning.type";
import type { PositionMarkerPosition } from "@/modules/position";
import type { PdfViewerClickCoordinates, PdfViewerSize } from "@/ui/pdf-viewer";

import {
  convertDatasetCoordinatesToRenderPosition,
  convertRenderCoordinatesToDatasetCoordinates,
} from "@/modules/position";

export const getPlanPositioningCoordinatesInfos = (
  coordinates?: PlanPositioningCoordinates
) => {
  if (!coordinates) return undefined;

  // skip `z` coordinate declaration, not used in this component
  const [x, y, _z, page] = coordinates.split(",");

  const infos: PlanPositioningCoordinateInfos = {
    x: parseFloat(x ?? 0),
    y: parseFloat(y ?? 0),
    page: parseInt(page ?? 1),
  };

  return infos;
};

export const getPlanPositioningCoordinatesPage = (
  coordinates?: PlanPositioningCoordinates
) => {
  return getPlanPositioningCoordinatesInfos(coordinates)?.page;
};

export const convertPositionCoordinatesToMarkerCoordinates = (
  coordinates?: PlanPositioningCoordinates,
  pdfPageSize?: PdfViewerSize
) => {
  const positionInfos = getPlanPositioningCoordinatesInfos(coordinates);

  if (!positionInfos || !pdfPageSize) return undefined;

  const { x, y } = convertDatasetCoordinatesToRenderPosition(
    pdfPageSize,
    positionInfos
  );

  const marker: PositionMarkerPosition = {
    top: `${y}px`,
    left: `${x}px`,
  };

  return marker;
};

export const convertPdfClickCoordinatesToPositionCoordinates = (
  clickCoordinates: PdfViewerClickCoordinates,
  pdfPageSize: PdfViewerSize
): PlanPositioningCoordinates => {
  const { page } = clickCoordinates;

  const { x, y } = convertRenderCoordinatesToDatasetCoordinates(
    pdfPageSize,
    clickCoordinates
  );

  return `${x},${y},0,${page}`;
};
